<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows"
            :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
            <template v-slot:item="{ item }">
              <tr>
                <td><code>{{ item.WaybillCode }}</code></td>
                <td><code>{{ item.OrderCode }}</code></td>
                <td>
                  <div class="font-weight-medium">{{ item.CustomerCode }}</div>
                  <div class="caption grey--text">{{ item.CustomerName }}</div>
                </td>
                <td class="text-right">{{ item.PackageCount }}</td>
                <td class="text-right">{{ item.TotalWeight | currency('', 2) }}</td>
                <td class="text-right">{{ item.TotalVolume | currency('', 6) }}</td>
                <td class="text-right">{{ item.KGM | currency('', 2) }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import configs from '@/configs'
import Filtering from '@/components/Filtering'
import _ from 'lodash'

export default {
  name: 'CnWaybillList',
  components: {
    'hpo-filter': Filtering
  },
  data() {
    return {
      headers: [
        { text: 'Mã vận đơn', value: 'WaybillCode', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Mã đơn hàng', value: 'OrderCode', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Khách hàng', value: 'CustomerName', sortable: true, filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Số kiện', value: 'PackageCount', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Tổng cân', value: 'TotalWeight', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Tổng khối', value: 'TotalVolume', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'], decimal: 6 },
        { text: 'KGM', value: 'KGM', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Number'], decimal: 2 },
        { text: 'Ngày tạo', value: 'CreatedDate', sortable: true, filterable: true, dataType: configs.DATA_TYPE['Date'] }
      ],
      viewName: 'cn_waybill_list',
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: []
    }
  },

  computed: {
    ...mapState({
      items: state => state.cnWaybill.all.data,
      total_rows: state => state.cnWaybill.all.total,
      loading: state => state.cnWaybill.loading
    })
  },

  watch: {
    pagination: {
      handler: function () {
        let filterConditions = this.$store.state.commons.filterConditions
        this.filterConditions = filterConditions && filterConditions[this.viewName] ? filterConditions[this.viewName] : []
        this.filter_data()
      },
      deep: true
    }
  },

  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {})
    this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data)
  },

  beforeDestroy() {
    this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data)
  },

  methods: {
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = _.cloneDeep(configs.PAGINATION)
      this.pagination.sortBy = sortBy
      this.pagination.sortDesc = sortDesc
      this.filterConditions = filterConditions
      this.filter_data()
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions
      this.filter_data()
    },
    filter_data() {
      this.$store.dispatch('cnWaybill/getList', {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      })
    }
  }
}
</script>
